import React, { useState } from 'react';
import SuperMarket from './SuperMarket';
import MarketOptions1 from './MarketOptions1';
import './HomePage.css';
import TechStore from './TechStore';
import ElectricalAppliances from './ElectricalAppliances';
import BeautyCare from './BeautyCare';
import Boutique from './Boutique';
import Stationary from './Stationary';
import Services from './Services';
import Hotel from './Hotel';
import BillGenerator from './BillGenerator';
import SimpleInvoice from './SimpleInvoice';
import { Link } from 'react-router-dom';

function HomePage() {
  const [selectedOption, setSelectedOption] = useState('SuperMarket');

  return (
    <div className="home-container">
      {/* <header className="home-banner">
        <h1>Welcome to JALM</h1>
        <p>Your hassle-free solution for smart invoicing</p>
      </header> */}

      <div className="selector-section">
        <label htmlFor="mode-select">Choose Business Mode:</label>
        <select
          id="mode-select"
          value={selectedOption}
          onChange={(e) => setSelectedOption(e.target.value)}
        >
          <option value="SuperMarket">🛒 SuperMarket</option>
          <option value="TechStore">🧰 Tech Retail Store</option>
           <option value="ElectricalAppliances">⚡ ElectricalAppliances Store</option>
           <option value="BeautyCare">💇‍♀️ Beauty & Personal Care</option>
           <option value="Stationary">✏️ Stationary & Gift Store 🎁</option>
            <option value="Boutique">💇🛍️ Boutique Store</option>
             <option value="Services">👨‍🔧🔧 Services🏢🚚</option>
             <option value="Hotel">👨‍🔧 Hotel/Restaurant/Inn 🏢</option>
             <option value="SimpleInvoice"> 🧾Simple Invoice </option>
             
        </select>
      </div>

      {selectedOption === 'SuperMarket' && (
        <section className="home-section">
          <h2>🛒 SuperMarket</h2>
          <SuperMarket />
        </section>
      )}

      {selectedOption === 'TechStore' && (
        <section className="home-section">
          <h2>🧰 Tech Retail Store</h2>
          <TechStore />
        </section>
      )}

        {selectedOption === 'ElectricalAppliances' && (
        <section className="home-section">
          <h2>⚡ Electrical Appliances Store</h2>
          <ElectricalAppliances />
        </section>
      )}

        {selectedOption === 'BeautyCare' && (
        <section className="home-section">
          <h2>  💇‍♀️Beauty & Personal Care</h2>
          <BeautyCare />
        </section>
      )}

{selectedOption === 'Stationary' && (
        <section className="home-section">
          <h2> ✏️ Stationary & Gift Store 🎁</h2>
          <Stationary />
        </section>
      )}

      {selectedOption === 'Boutique' && (
        <section className="home-section">
          <h2> 💇🛍️ Boutique store</h2>
          <Boutique />
        </section>
      )}

{selectedOption === 'Services' && (
        <section className="home-section">
          <h2>👨‍🔧🔧 Services🏢🚚</h2>
          < Services/>
        </section>
      )}
  {selectedOption === 'Hotel' && (
        <section className="home-section">
          <h2>👨‍🔧 Hotel/Restaurant/Stay 🏢</h2>
          < Hotel/>
        </section>
      )}

    {selectedOption === 'SimpleInvoice' && (
        <section className="home-section">
          <h2> 🧾Simple Invoice </h2>
          < SimpleInvoice/>
        </section>
      )}

      <footer className="home-footer">
        <div className="footer-banner1">
          Thank you for choosing JAL Market to simplify your invoicing smooth and hassle-free! 🛒
        </div>
        <div>
          <img className="image-ban" src="./Images/jalm.png" alt="Just A Little Market" width="50" height="50" />
          
        </div>
        <p>© 2025 JALM  • Easy Invoice. &nbsp; &nbsp;   <Link to="/PrivacyPolicy" >Privacy Policy</Link>
          </p>
          
      </footer>
    </div>
  );
}

export default HomePage;
